import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  Stack,
  styled,
} from "@mui/material"
import { useState } from "react"
import VisibilityIcon from "@mui/icons-material/Visibility"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

export const CardContainer = ({
  SummaryContent,
  ActionButtons,
  DetailsContent,
  Content,
  disableEditDelete,
  expanded,
  cardTitle,
}) => {
  const [expand, setExpand] = useState(expanded || false)
  const toggleAcordion = () => setExpand((prev) => !prev)

  return (
    <>
      <Accordion
        expanded={expand}
        elevation={1}
        sx={{
          px: 2,
          display: {
            xs: "none",
            lg: "block",
          },
        }}
      >
        <AccordionSummary
          expandIcon={<VisibilityIcon onClick={toggleAcordion} />}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap={2}
            sx={{ width: "100%", pr: 2 }}
          >
            <Grid container spacing={2}>
              {SummaryContent}
            </Grid>

            <Stack sx={{ flex: "none" }} direction="row" gap={1}>
              {ActionButtons}
              {!disableEditDelete && (
                <>
                  <IconButton>
                    <EditIcon />
                  </IconButton>
                  <IconButton>
                    <DeleteIcon />
                  </IconButton>
                </>
              )}
            </Stack>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap={2}
            sx={{ width: "100%" }}
          >
            {DetailsContent}
          </Stack>
          {Content}
        </AccordionDetails>
      </Accordion>
      <Card sx={{ display: { sm: "none" }, my: 1 }}>
        <CardHeader title={cardTitle} />
        <CardContent>
          <Grid container spacing={1}>
            {SummaryContent}
          </Grid>
        </CardContent>
        <CardActions disableSpacing>
          {!disableEditDelete && (
            <>
              <IconButton>
                <EditIcon />
              </IconButton>
              <IconButton>
                <DeleteIcon />
              </IconButton>
            </>
          )}
          {ActionButtons}

          <ExpandMore expand={expand} onClick={toggleAcordion}>
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
        <Collapse in={expand} timeout="auto" unmountOnExit>
          <CardContent>
            <Grid container spacing={1}>
              {DetailsContent}
            </Grid>
          </CardContent>{" "}
        </Collapse>
      </Card>
    </>
  )
}

const ExpandMore = styled((props) => {
  const { expand, ...other } = props
  return <IconButton {...other} />
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}))
